var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakersLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1300,
    viewBox: "0 0 876 1300",
    width: 876,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m664.521 448.298c36.643 118.691 94.904 218.426 170.914 233.497 14.432 2.861 27.936 2.989 40.565.654m-211.479-234.151c-72.008-233.244-60.536-539.693 63.778-420.7014 143.899 137.7384-.264 353.3474-63.778 420.7014zm0 0c-11.821 12.535-20.848 19.935-24.705 20.742-24.578 5.141-121.243-107.964-188.705 9.95-67.462 117.913 393.683 517.356 173.268 625.28-220.416 107.92-478.461-25.67-623.379 194.54",
    stroke: "#faf7f5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakersLine);
export default __webpack_public_path__ + "static/media/speakers-line.4ce9a8fa2184ff23ace7fb468f06f624.svg";
export { ForwardRef as ReactComponent };